import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@/ui/Button/Button'
import RemoveCircle from '@/icons/Remove'

export class FileInputPreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hovered: false,
    }
  }

  componentWillUnmount() {
    const { file } = this.props

    if (file.preview) {
      window.URL.revokeObjectURL(file.preview)
    }
  }

  handleMouseOut = () => this.setState({ hovered: false })
  handleMouseOver = () => this.setState({ hovered: true })

  render() {
    const { children, onRemove, theme } = this.props

    return (
      <div
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        style={{ height: '100%' }}
      >
        <Button classes="clean" onClick={onRemove} theme={theme}>
          <RemoveCircle color={theme['text-primary']} />
        </Button>
        {children}
      </div>
    )
  }
}

FileInputPreview.propTypes = {
  children: PropTypes.element.isRequired,
  file: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onRemove: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
}

FileInputPreview.defaultProps = {
  file: undefined,
}

export default FileInputPreview



// WEBPACK FOOTER //
// ./ui/Input/FileInputPreview.js